

export default function TitleComponent() {
    return (
        <div className="TitleComponent title">Street Sweeping Notifier</div>



    )




}